import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const PendingSurveyAssignmentErrorModel = types.model(
  "PendingSurveyAssignmentErrorModel",
  {
    respondentsSelected: types.integer,
    respondentsAssigned: types.integer,
    respondentsUnassigned: types.integer,
  },
);

export const createPendingSurveyAssignmentErrorModel = (
  pendingSurveyAssignmentError: SnapshotIn<
    typeof PendingSurveyAssignmentErrorModel
  >,
): Instance<typeof PendingSurveyAssignmentErrorModel> =>
  PendingSurveyAssignmentErrorModel.create(pendingSurveyAssignmentError);
